import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ProgramasService } from '../../services/programas.service';
import { Pais } from '../../models/pais.model';
import { Programa } from '../../models/programas.model';
import { PaisesService } from '../../services/paises.service';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ObrasService } from '../../services/obras.service';
import { TipoObrasService } from '../../services/tipoObras.service';
import TipoObra from '../../models/tipoObra.model';
import { JefeEquiposService } from '../../services/jefeEquipos.service';
import JefeEquipo from '../../models/jefeEquipo.model';
import { MonedasService } from '../../services/monedas.service';
import Moneda from '../../models/moneda.model';
import { EstadosEjecucionService } from '../../services/estadosEjecucion.service';
import EstadoEjecucion from '../../models/estadoEjecucion.model';

import ReactDataGrid, { TextEditor } from 'react-data-grid';
import { useNavigate, useParams } from 'react-router-dom';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationAlert } from '../../models/notifications.model';
import { General } from '../../services/general';
import ObraTemporalFilter from '../../models/obraTemporalFilter.model';
import { ObraAppTemporal } from '../../models/obraAppTemporal.model';
import { ObraApp } from '../../models/obraApp.model';
import Loading from '../shared/loading/Loading.component';
import ObraFilter from '../../models/obraFilter.model';
const moment = require('moment');

export const formateDate = (date: Date) => {
    const sliced = date.toString().split('-')[0];
    return new Date(sliced);
};

export default function DetailProgramNotification(props: any) {
    const parameters: any = useParams<{}>();
    const programasService = ProgramasService({ locale: 'en' });
    const notificationsService = NotificationsService({ locale: 'en' });
    const paisesService = PaisesService({ locale: 'en' });
    const obrasService = ObrasService({ locale: 'en' });
    const tipoObrasService = TipoObrasService({ locale: 'en' });
    const jefeEquiposService = JefeEquiposService({ locale: 'en' });
    const monedasService = MonedasService({ locale: 'en' });
    const estadosEjecucionService = EstadosEjecucionService({ locale: 'en' });
    const [countries, setCountries] = useState<Pais[]>([]);
    const [programs, setPrograms] = useState<Programa[]>([]);
    const [obrasType, setObrasType] = useState<TipoObra[]>([]);
    const [jefeDeEquipos, setJefeDeEquipos] = useState<JefeEquipo[]>([]);
    const [currency, setCurrency] = useState<Moneda[]>([]);
    const [estadoDeEjecucion, setEstadoDeEjecucion] = useState<EstadoEjecucion[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [columnas, setColumnas] = React.useState<any[]>();
    const [columnasGrid, setColumnasGrid] = React.useState<any[]>();
    const [currentProgram, setCurrentProgram] = React.useState<number>(0);
    const currentDate = new Date();
    const [currentYear, setCurrentYear] = React.useState<number>(currentDate.getFullYear());
    const [currentMonth, setCurrentMonth] = React.useState<number>(currentDate.getMonth() + 1);
    const [edit, setEdit] = React.useState<boolean>(false);
    const [notificacion, setNotificacion] = React.useState<NotificationAlert>();

    const [obras, setObras] = React.useState<ObraAppTemporal[]>([]);
    const defaultPrograma: Programa = {
        oid: 0,
        descripcion: '',
        codigo: 0,
        optimisticLockField: 0,
    };
    const [programSelected, setProgramSelected] = React.useState<any>({
        value: defaultPrograma,
    });
    const user = JSON.parse(localStorage.getItem('currentUsr')!);

    const navigate = useNavigate();

    const fetchServices = () => {
        return new Promise((resolve, reject) => {
            const pCountries = paisesService.getPaises();
            const pPrograms = programasService.getProgramas();
            const pTipoObras = tipoObrasService.getTipoObras();
            const pJefeEquipos = jefeEquiposService.getJefeEquipos();
            const pMonedas = monedasService.getMonedas();
            const pEstadosEjecucion = estadosEjecucionService.getEstadosEjecucion();
            const p_id = parameters['id'];
            if (p_id) {
                const id = Number(p_id);
                const pNotification = notificationsService.getNotifications({ id: id });
                Promise.all([
                    pCountries,
                    pPrograms,
                    pTipoObras,
                    pJefeEquipos,
                    pMonedas,
                    pEstadosEjecucion,
                    pNotification,
                ]).then((response) => {
                    const paises = response[0].data;
                    const programas = response[1].data;
                    const tipoObras = response[2].data;
                    const jefeEquipos = response[3].data;
                    const estadosEjecucion = response[5].data;
                    const monedas = response[4].data;
                    const notification = response[6].data[0];
                    setNotificacion(notification);

                    setCountries(paises);

                    setPrograms(programas);
                    setObrasType(tipoObras);
                    setJefeDeEquipos(jefeEquipos);
                    setCurrency(monedas);
                    setEstadoDeEjecucion(estadosEjecucion);

                    setEdit(true);
                    if (notification.programId && notification.year && notification.month) {
                        setCurrentProgram(notification.programId);
                        const program = response[1].data.filter(
                            (s) => s.oid === notification.programId
                        )[0];
                        setProgramSelected({ value: program });

                        setCurrentYear(notification.year);
                        setCurrentMonth(notification.month);
                        setTimeout(() => {
                            loadObras(
                                notification.programId as number,
                                notification.year as number,
                                notification.month as number,
                                true,
                                paises,
                                programas,
                                tipoObras,
                                jefeEquipos,
                                monedas,
                                estadosEjecucion,
                                notification
                            );
                        });
                    }

                    resolve(true);
                });
            }
        });
    };

    const years = () => {
        let result = [];
        for (let i = new Date().getFullYear(); i < new Date().getFullYear() + 10; i++) {
            result.push(i);
        }
        return result;
    };

    const months = () => {
        let result = [];
        for (let i = 0; i < 12; i++) {
            result.push(i + 1);
        }
        return result;
    };

    const loadObras = async (
        program: number,
        year: number,
        month: number,
        isEdit = false,
        paises: Pais[],
        programas: Programa[],
        tipoObras: TipoObra[],
        jefeEquipos: JefeEquipo[],
        monedas: Moneda[],
        estadosEjecucion: EstadoEjecucion[],
        notification: NotificationAlert
    ) => {
        setLoading(true);
        const filter: ObraTemporalFilter = {
            notificationId: notification?.id,
        };
        obrasService.getObrasAppTemporales(filter).then((response: any) => {
            let result: ObraAppTemporal[] = [];
            let data = response.data;
            data.map((obra: ObraAppTemporal) => {
                obra.fecha = formateDate(new Date(obra.fecha));
                obra.fechaInicio = formateDate(new Date(obra.fechaInicio!));
                obra.fechaFinalizacionVigente = formateDate(
                    new Date(obra.fechaFinalizacionVigente!)
                );
                obra.fechaFinalizacionEstimada = formateDate(
                    new Date(obra.fechaFinalizacionEstimada!)
                );
                obra.mesUltPagoContratista = obra.mesUltPagoContratista
                    ? formateDate(new Date(obra.mesUltPagoContratista))
                    : obra.mesUltPagoContratista;
                return obra;
            });
            let filterObras: ObraFilter = {};
            if (data.length > 0) {
                filterObras = {
                    programa: data[0].programa,
                    Oid_Obras: data.map((o: any) => o.oidObra),
                };
            }
            obrasService.getObrasApp(filterObras).then((obraAppResult: any) => {
                for (let i = 0; i < data.length; i++) {
                    let obra: ObraAppTemporal = {
                        index: i,
                        oid: isEdit ? data[i].oid : 0,
                        oidObra: data[i].oidObra,
                        notificationId: data[i].notificationId,
                        fecha: new Date(data[i].fecha),
                        nombre: data[i].nombre,
                        tramo: data[i].tramo,
                        programa: data[i].programa,
                        programItem: programas.filter((s) => s.oid === data[i].programa)[0],
                        tipoObra: data[i].tipoObra,
                        tipoObraItem: tipoObras.filter((s) => s.oid === data[i].tipoObra)[0],
                        pais: data[i].pais,
                        paisItem: paises.filter((s) => s.oid === data[i].pais)[0],
                        estadoEjecucion: data[i].estadoEjecucion,
                        estadoEjecucionItem: estadosEjecucion.filter(
                            (s) => s.oid === data[i].estadoEjecucion
                        )[0],
                        provincia: data[i].provincia,
                        longitudKm: data[i].longitudKm,
                        moneda: data[i].moneda,
                        monedaItem: monedas.filter((s) => s.oid === data[i].moneda)[0],
                        montoInicial: data[i].montoInicial,
                        montoVigente: data[i].montoVigente,
                        porcentajeBid: data[i].porcentajeBid,
                        porcentajeContrapartida: data[i].porcentajeContrapartida,
                        fechaInicio: data[i].fechaInicio ? new Date(data[i].fechaInicio) : null,
                        plazoInicialMeses: data[i].plazoInicialMeses,
                        fechaFinalizacionEstimada: data[i].fechaFinalizacionEstimada
                            ? new Date(data[i].fechaFinalizacionEstimada)
                            : null,
                        cantidadManoObra: data[i].cantidadManoObra,
                        mesUltPagoContratista: data[i].mesUltPagoContratista
                            ? new Date(data[i].mesUltPagoContratista)
                            : null,
                        pagado: data[i].pagado,
                        sobreCostoEstimado: data[i].sobreCostoEstimado,
                        jefeEquipo: data[i].jefeEquipo,
                        jefeEquipoItem: jefeEquipos.filter((s) => s.oid === data[i].jefeEquipo)[0],
                        fechaFinalizacionVigente: data[i].fechaFinalizacionVigente
                            ? new Date(data[i].fechaFinalizacionVigente)
                            : null,
                        tipoCambio: data[i].tipoCambio,
                        pendientePorVerificar: data[i].pendientePorVerificar,
                        nota: data[i].nota,
                        orden: data[i].orden,
                        cantidadObreroCesados: data[i].cantidadObreroCesados,
                        actaSuspencionMesFirma: data[i].actaSuspencionMesFirma
                            ? new Date(data[i].actaSuspencionMesFirma)
                            : null,
                        latitud: data[i].latitud,
                        longitud: data[i].longitud,
                        actaSuspencionFirmada: data[i].actaSuspencionFirmada,
                        pagoStockMateriales: data[i].pagoStockMateriales,
                        sobreCostoEstimadoNoMaterializado:
                            data[i].sobreCostoEstimadoNoMaterializado,
                        flexibilizacionClausulasContractuales:
                            data[i].flexibilizacionClausulasContractuales,
                        problemaCadenaSuministros: data[i].problemaCadenaSuministros,
                        nuevoCronograma: data[i].nuevoCronograma,
                        limitacionActividadesAdministrativas:
                            data[i].limitacionActividadesAdministrativas,
                        seSuscribioAdenda: data[i].seSuscribioAdenda,
                        optimisticLockField: data[i].optimisticLockField,
                        gcrecord: data[i].gcrecord,
                        anoFinalizaciónContrato: data[i].anoFinalizaciónContrato,
                        apareceEnBaseDeDatos: data[i].apareceEnBaseDeDatos,
                        avanceDePlazoPlazoIntermedio: data[i].avanceDePlazoPlazoIntermedio,
                        clasificacionDeSobrecostos: data[i].clasificacionDeSobrecostos,
                        clasificacionPorKm: data[i].clasificacionPorKm,
                        clasificacionPorMontos: data[i].clasificacionPorMontos,
                        clasificacionPorPlazo: data[i].clasificacionPorPlazo,
                        clasificacionPorSobreplazo: data[i].clasificacionPorSobreplazo,
                        contratista1: data[i].contratista1,
                        contratista2: data[i].contratista2,
                        contratistaConsorciosObra: data[i].contratistaConsorciosObra,
                        desapareceDeBaseDeDatos: data[i].desapareceDeBaseDeDatos,
                        empresaSupervisora: data[i].empresaSupervisora,
                        estadoDeAvanceGeneral: data[i].estadoDeAvanceGeneral,
                        externalIdCaptudata1: data[i].externalIdCaptudata1,
                        externalIdcaptudata: data[i].externalIdcaptudata,
                        f103: data[i].f103,
                        fechaActualizacion: new Date(),
                        fechaDeOrdenDeInicioEnMesAño: data[i].fechaDeOrdenDeInicioEnMesAño,
                        fechaRecibioInformación: data[i].fechaRecibioInformación
                            ? new Date(data[i].fechaRecibioInformación)
                            : null,
                        ficConTazasCambioDiferenciadas: data[i].ficConTazasCambioDiferenciadas,
                        ficmetodologicoContratosActivos: data[i].ficmetodologicoContratosActivos,
                        ficmetodologicoContratosActivosSinCeros:
                            data[i].ficmetodologicoContratosActivosSinCeros,
                        fpcmetodologicoContratosActivos: data[i].fpcmetodologicoContratosActivos,
                        fpcmetodologicoContratosActivosSinCeros:
                            data[i].fpcmetodologicoContratosActivosSinCeros,
                        localizacion: data[i].localizacion,
                        manoObraPorMontoDeInversionMillones:
                            data[i].manoObraPorMontoDeInversionMillones,
                        mesDelÚltimoPagoAlContratistaEnMesAño:
                            data[i].mesDelÚltimoPagoAlContratistaEnMesAño,
                        montoContractualDolares: data[i].montoContractualDolares,
                        montoContractualDolaresEnMillones:
                            data[i].montoContractualDolaresEnMillones,
                        montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                            data[i].montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                        montoContractualVigenteModificadoDolares:
                            data[i].montoContractualVigenteModificadoDolares,
                        montoContractualVigenteModificadoDolaresEnMillones:
                            data[i].montoContractualVigenteModificadoDolaresEnMillones,
                        montoContractualVigenteModificadoDólaresConTasaDeCam:
                            data[i].montoContractualVigenteModificadoDólaresConTasaDeCam,
                        muestraDeChequeo: data[i].muestraDeChequeo,
                        nacionalidadContratista: data[i].nacionalidadContratista,
                        nacionalidadEmpresaSupervisora: data[i].nacionalidadEmpresaSupervisora,
                        notaFinalEstadoGeneral: data[i].notaFinalEstadoGeneral,
                        notaFinalSobrecostos: data[i].notaFinalSobrecostos,
                        notaFinalSobreplazo: data[i].notaFinalSobreplazo,
                        plazoContractualVigente: data[i].plazoContractualVigente,
                        plazoContractualVigentePasoIntermedio:
                            data[i].plazoContractualVigentePasoIntermedio,
                        plazoInicialPorKm: data[i].plazoInicialPorKm,
                        plazoVigentePorKm: data[i].plazoVigentePorKm,
                        ponderadorFicMca: data[i].ponderadorFicMca,
                        ponderadorFicMcasinCeros: data[i].ponderadorFicMcasinCeros,
                        ponderadorPfc: data[i].ponderadorPfc,
                        ponderadorPfcMcasinCeros: data[i].ponderadorPfcMcasinCeros,
                        porcentajeAvanceAcumulado: data[i].porcentajeAvanceAcumulado,
                        porcentajeAvanceDePlazo: data[i].porcentajeAvanceDePlazo + 100,
                        precioInicialPorKmMillones: data[i].precioInicialPorKmMillones,
                        precioVigentePorKmMillones: data[i].precioVigentePorKmMillones,
                        sobrecostosMaterializados: data[i].sobrecostosMaterializados,
                        sobrecostosUsd: data[i].sobrecostosUsd,
                        sobrecostosUsdenMillones: data[i].sobrecostosUsdenMillones,
                        sobreplazoMesesCalculado: data[i].sobreplazoMesesCalculado,
                        subRegion: data[i].subRegion,
                        supervisora1: data[i].supervisora1,
                        tipoCambioPorMesYmoneda: data[i].tipoCambioPorMesYmoneda,
                        tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                            data[i].tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                        tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                            data[i].tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                        totalPagoHastaLaFechaDolares: data[i].totalPagoHastaLaFechaDolares,
                        _: data[i]._,
                        _2020: data[i]._2020,
                        _2021: data[i]._2021,
                        _2022: data[i]._2022,
                        _2023: data[i]._2023,
                        _2024: data[i]._2024,
                        _2025: data[i]._2025,
                        rowClass:
                            data[i].estadoEjecucion &&
                            estadosEjecucion.filter((s) => s.oid === data[i].estadoEjecucion)[0]
                                .nombre === 'Finalizada'
                                ? 'rowProjectClosed'
                                : null,
                        locked: true, // data[i].estadoEjecucion && estadosEjecucion.filter(s => s.oid === data[i].estadoEjecucion)[0].nombre === 'Finalizada'
                    };

                    if (obra.fecha !== null) {
                        obra.fecha = new Date(obra.fecha);
                    }
                    const programFilter = programas.filter((s) => s.oid === obra.programa);
                    if (programFilter.length > 0) obra.programItem = programFilter[0];

                    const countryFilter = paises.filter((s) => s.oid === obra.pais);
                    if (countryFilter.length > 0) obra.paisItem = countryFilter[0];
                    result.push(obra);
                }
                setObras(result);

                loadGridColumns(
                    paises,
                    programas,
                    tipoObras,
                    jefeEquipos,
                    monedas,
                    estadosEjecucion,
                    result,
                    obraAppResult.data
                );
                setLoading(false);
            });
        });
        // }
    };

    const getHeader = (column: string) => {
        const title = column;
        return (
            <div>
                <div>
                    <span className='fecha-grid'></span>
                    <div className='tooltip-grid'>
                        <span className='tooltip-Tooltip_de_moneda'></span>
                    </div>
                    {title}
                </div>
            </div>
        );
    };

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            fetchServices();
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function TimestampFormatter({ timestamp }: { timestamp: number }) {
        return <>{timestamp ? moment(timestamp).format('MM/DD/YYYY') : ''}</>;
    }

    function isChanged(row: any, obrasAppR: ObraApp[], field: string, isDate?: boolean): string {
        let result = '';
        const obraAppFilter = obrasAppR.filter((s) => s.oid === row.oidObra);
        if (obraAppFilter.length > 0) {
            const obraAppItem = obraAppFilter[0] as any;
            let rowValue: string = row[field]?.toString();
            if (isDate && rowValue && !isNaN(Date.parse(rowValue))) {
                rowValue = new moment(rowValue).format('MM/DD/YYYY').toString();
            }
            let obraAppValue: string = obraAppItem[field]?.toString();
            if (isDate && obraAppValue && !isNaN(Date.parse(obraAppValue))) {
                obraAppValue = new moment(obraAppValue).format('MM/DD/YYYY').toString();
            }
            if (rowValue !== obraAppValue) {
                result = 'changed';
            }
        }

        return result;
    }

    function loadGridColumns(
        paisItems: Pais[],
        programItems: Programa[],
        tipoObras: TipoObra[],
        jefeEquipos: JefeEquipo[],
        monedas: Moneda[],
        estadosEjecucion: EstadoEjecucion[],
        obras: ObraAppTemporal[],
        obrasAppR: ObraApp[]
    ) {
        const result: any[] = [
            {
                key: 'fecha',
                visible: true,
                name: 'Fecha',
                minWidth: 110,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fecha} />;
                },
                frozen: true,
            },
            {
                key: 'programa',
                visible: true,
                name: 'Programa',
                minWidth: 110,
                editable: false,
                resizable: true,
                formatter(props: { row: ObraApp }) {
                    return <>{props.row.programItem?.descripcion}</>;
                },
                editor: (props: any) => (
                    <Select
                        key={`programa${props.row.oid}`}
                        isDisabled={true}
                        options={programItems.map((item: Programa) => {
                            return { value: item.oid?.toString(), label: item.descripcion };
                        })}
                        defaultValue={{
                            value: props.row.programItem.oid.toString(),
                            label: props.row.programItem.descripcion,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.programa = Number(e.value);
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        jefeEquipo: Number(e.value),
                                        programaItem: programs.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                    },
                                    true
                                );
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'pais',
                visible: true,
                name: 'País',
                minWidth: 100,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return <>{props.row.paisItem.nombre}</>;
                },
                editor: (props: any) => (
                    <Select
                        key={`pais${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.pais = Number(e.value);
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        pais: Number(e.value),
                                        paisItem: paisItems.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                    },
                                    true
                                );
                            }
                        }}
                        options={paisItems.map((pais: Pais) => {
                            return { value: pais.oid, label: pais.nombre };
                        })}
                        defaultValue={{
                            value: props.row.paisItem.oid,
                            label: props.row.paisItem.nombre,
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'nombre',
                visible: true,
                name: 'Nombre de la obra',
                minWidth: 150,
                editable: false,
                resizable: true,
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.nombre}
                        onChange={(e: any) => {
                            props.row.nombre = e.target.value;
                            props.onRowChange({ ...props.row, nombre: props.row.nombre });
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'moneda',
                visible: true,
                name: 'Moneda Local',
                minWidth: 70,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return <>{props.row.monedaItem.nombre}</>;
                },
                editor: (props: any) => (
                    <Select
                        isDisabled={props.row.locked}
                        options={monedas.map((item: Moneda) => {
                            return { value: item.oid?.toString(), label: item.nombre };
                        })}
                        defaultValue={{
                            value: props.row.monedaItem.oid.toString(),
                            label: props.row.monedaItem.nombre,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.moneda = Number(e.value);
                                props.row.monedaItem = monedas.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange({
                                    ...props.row,
                                    moneda: props.row.moneda,
                                    monedaItem: props.row.monedaItem,
                                });
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'tipoCambio',
                visible: true,
                name: getHeader('Tipo cambio'),
                minWidth: 120,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'tipoCambio'),
                formatter(props: any) {
                    return <>{Number(props.row.tipoCambio.toFixed(4))}</>;
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        defaultValue={props.row.tipoCambio}
                        placeholder={
                            props.row !== undefined && props.row.invalidInitialAmount
                                ? 'Campo requerido'
                                : 'Ingrese el monto inicial'
                        }
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'montoInicial',
                visible: true,
                name: 'Monto Contractual Inicial',
                minWidth: 150,
                editable: false,
                resizable: true,
                formatter: (props: any) => new Intl.NumberFormat().format(props.row.montoInicial),
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.montoInicial}
                        onChange={(e: any) => {
                            if (e && isNaN(Number(e.target.value))) {
                                return;
                            } else {
                                props.row.montoInicial = Number(e.target.value);
                                props.onRowChange({
                                    ...props.row,
                                    montoInicial: props.row.montoInicial,
                                });
                            }
                        }}
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'montoVigente',
                visible: true,
                name: 'Monto Contractual Vigente',
                minWidth: 150,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'montoVigente'),
                formatter: (props: any) => new Intl.NumberFormat().format(props.row.montoVigente),
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.montoVigente}
                        onChange={(e: any) => {
                            if (e && isNaN(Number(e.target.value))) {
                                return;
                            } else {
                                props.row.montoVigente = Number(e.target.value);
                                props.onRowChange({
                                    ...props.row,
                                    montoVigente: props.row.montoVigente,
                                });
                            }
                        }}
                    />
                ),
            },
            {
                key: 'fechaInicio',
                visible: true,
                name: 'Fecha de orden de inicio',
                minWidth: 110,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'fechaInicio', true),
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fechaInicio} />;
                },
                editable: false,
                resizable: true,
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'mesUltPagoContratista',
                visible: true,
                name: 'Mes último pago al contratista',
                minWidth: 150,
                cellClass: (props: any) =>
                    isChanged(props, obrasAppR, 'mesUltPagoContratista', true),
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.mesUltPagoContratista} />;
                },
                editable: false,
                resizable: true,
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'pagado',
                visible: true,
                name: 'Total pago hasta la fecha',
                minWidth: 150,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'pagado'),
                formatter: (props: any) => new Intl.NumberFormat().format(props.row.pagado),
            },
            {
                key: 'fechaFinalizacionVigente',
                visible: true,
                name: 'Fecha de finalización vigente',
                minWidth: 110,
                cellClass: (props: any) =>
                    isChanged(props, obrasAppR, 'fechaFinalizacionVigente', true),
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fechaFinalizacionVigente} />;
                },

                editorOptions: {
                    editOnClick: true,
                },
                editable: false,
                resizable: true,
            },
            {
                key: 'fechaFinalizacionEstimada',
                visible: true,
                name: 'Fecha de finalización estimada',
                minWidth: 180,
                editable: false,
                resizable: true,
                cellClass: (props: any) =>
                    isChanged(props, obrasAppR, 'fechaFinalizacionEstimada', true),
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fechaFinalizacionEstimada} />;
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={
                            !isNaN(Date.parse(props.row.fechaFinalizacionEstimada))
                                ? new moment(props.row.fechaFinalizacionEstimada)
                                      .format('MM/DD/YYYY')
                                      .toString()
                                : ''
                        }
                        onChange={(e: any) => {
                            if (e && isNaN(Date.parse(e.target.value))) {
                                return;
                            } else {
                                props.row.fechaFinalizacionEstimada = new Date(
                                    new moment(e.target.value).format('MM/DD/YYYY')
                                );
                                props.onRowChange({
                                    ...props.row,
                                    fechaFinalizacionEstimada: props.row.fechaFinalizacionEstimada,
                                });
                            }
                        }}
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'cantidadManoObra',
                visible: true,
                name: 'Cantidad mano de obra directa en campo',
                minWidth: 75,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'cantidadManoObra'),
                formatter(props: any) {
                    return <span>{props.row.cantidadManoObra}</span>;
                },
            },
            {
                key: 'estadoEjecucion',
                visible: true,
                name: 'Estado de Ejecución',
                minWidth: 150,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'estadoEjecucion'),
                formatter(props: any) {
                    return (
                        <>
                            <span>{props.row.estadoEjecucionItem?.nombre}</span>
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        key={`estadoEjecucion${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.estadoEjecucion = Number(e.value);
                                props.row.estadoEjecucionItem = estadosEjecucion.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        estadoEjecucion: Number(e.value),
                                        estadoEjecucionItem: props.row.estadoEjecucionItem,
                                    },
                                    true
                                );
                            }
                        }}
                        options={estadosEjecucion.map((estado: EstadoEjecucion) => {
                            return {
                                value: estado.oid && estado.oid.toString(),
                                label: estado.nombre,
                            };
                        })}
                        defaultValue={{
                            value: props.row.estadoEjecucionItem.oid.toString(),
                            label: props.row.estadoEjecucionItem.nombre,
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'plazoInicialMeses',
                visible: true,
                name: 'Plazo contractual inicial (meses)',
                minWidth: 50,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'plazoInicialMeses'),
                formatter(props: any) {
                    return <span>{props.row.plazoInicialMeses}</span>;
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.plazoInicialMeses}
                    />
                ),
            },
            {
                key: 'sobreCostoEstimado',
                visible: true,
                name: 'Sobrecostos estimados',
                minWidth: 160,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'sobreCostoEstimado'),
                formatter(props: any) {
                    return <span>{props.row.sobreCostoEstimado}</span>;
                },
            },
            {
                key: 'seSuscribioAdenda',
                visible: true,
                name: '¿Se suscribio adenda del contrato de obra?',
                minWidth: 80,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'seSuscribioAdenda'),
                formatter(props: any) {
                    return <span>{props.row.seSuscribioAdenda}</span>;
                },
            },
            {
                key: 'jefeEquipo',
                visible: true,
                name: 'Jefe de Equipo',
                minWidth: 150,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'jefeEquipo'),
                formatter(props: any) {
                    return (
                        <>
                            <span>{props.row.jefeEquipoItem.nombre}</span>
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        key={`jefeEquipo${props.row.oid}`}
                        autoFocus={true}
                        options={jefeEquipos.map((jefe: JefeEquipo) => {
                            return { value: jefe.oid?.toString(), label: jefe.nombre };
                        })}
                        defaultValue={{
                            value: props.row.jefeEquipoItem.oid.toString(),
                            label: props.row.jefeEquipoItem.nombre,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.jefeEquipo = Number(e.value);
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        jefeEquipo: Number(e.value),
                                        jefeEquipoItem: jefeEquipos.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                    },
                                    true
                                );
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'tramo',
                visible: true,
                name: 'Tramo de la obra',
                minWidth: 250,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'tramo'),
                formatter(props: any) {
                    return <span>{props.row.tramo}</span>;
                },
            },
            {
                key: 'tipoObra',
                visible: true,
                name: 'Tipo de Obra',
                minWidth: 250,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'tipoObra'),
                formatter(props: any) {
                    return (
                        <>
                            <span>{props.row.tipoObraItem.descripcion}</span>
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        key={`tipoObra${props.row.oid}`}
                        isDisabled={props.row.locked}
                        options={tipoObras.map((item: TipoObra) => {
                            return { value: item.oid?.toString(), label: item.descripcion };
                        })}
                        defaultValue={{
                            value: props.row.tipoObraItem?.oid?.toString(),
                            label: props.row.tipoObraItem?.descripcion,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.tipoObra = Number(e.value);
                                props.row.tipoObraItem = tipoObras.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        tipoObra: Number(e.value),
                                        tipoObraItem: props.row.tipoObraItem,
                                    },
                                    true
                                );
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'provincia',
                visible: true,
                name: 'Departamento/Provincia',
                minWidth: 180,
                editor: TextEditor,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'provincia'),
                formatter(props: any) {
                    return <span>{props.row.provincia}</span>;
                },
            },
            {
                key: 'longitudKm',
                visible: true,
                name: 'Longitud total del contrato (km)',
                minWidth: 100,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'longitudKm'),
                formatter(props: any) {
                    return <span>{props.row.longitudKm}</span>;
                },
                editor: (props: any) => (
                    <input
                        key={`longitudKm${props.row.oid}`}
                        disabled={props.row.locked}
                        autoFocus
                        type='number'
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.longitudKm = e.target.valueAsNumber;
                                props.onRowChange({
                                    ...props.row,
                                    longitudKm: e.target.valueAsNumber,
                                });
                            }
                        }}
                        defaultValue={props.row.longitudKm}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'porcentajeBid',
                visible: true,
                name: '% BID',
                minWidth: 80,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'porcentajeBid'),
                formatter: (props: any) =>
                    new Intl.NumberFormat('locales', { style: 'percent' }).format(
                        props.row.porcentajeBid
                    ),
            },
            {
                key: 'porcentajeContrapartida',
                visible: true,
                name: '% Contrapartida',
                minWidth: 80,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'porcentajeContrapartida'),
                formatter: (props: any) =>
                    new Intl.NumberFormat('locales', { style: 'percent' }).format(
                        props.row.porcentajeContrapartida
                    ),
            },
            {
                key: 'latitud',
                visible: true,
                name: 'Latitud Coordenadas Geográficas',
                minWidth: 100,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'latitud'),
                formatter(props: any) {
                    return <span>{props.row.latitud}</span>;
                },
            },
            {
                key: 'longitud',
                visible: true,
                name: 'Longitud Coordenadas Geográficas',
                minWidth: 100,
                editable: false,
                resizable: true,
                cellClass: (props: any) => isChanged(props, obrasAppR, 'longitud'),
                formatter(props: any) {
                    return <span>{props.row.longitud}</span>;
                },
            },
        ];

        const columnsVisible = result.filter((obj) => obj.visible === true);
        setColumnasGrid(columnsVisible);
    }
    // const handleChange = (event: any) => {
    //   const name = event.target.name;
    //   setState({
    //     ...state,
    //     [name]: event.target.value,
    //   });
    // };

    const handleChangeYear = (event: any) => {
        setCurrentYear(Number(event.target.value));

        loadObras(
            currentProgram,
            event.target.value,
            currentMonth,
            edit,
            countries,
            programs,
            obrasType,
            jefeDeEquipos,
            currency,
            estadoDeEjecucion,
            notificacion as NotificationAlert
        );
    };

    const handleChangeMonth = (event: any) => {
        setCurrentMonth(Number(event.target.value));
        loadObras(
            currentProgram,
            currentYear,
            event.target.value,
            edit,
            countries,
            programs,
            obrasType,
            jefeDeEquipos,
            currency,
            estadoDeEjecucion,
            notificacion as NotificationAlert
        );
    };

    const handleChangeProgram = (event: any) => {
        setCurrentProgram(Number(event.target.value.oid));
        loadObras(
            event.target.value,
            currentYear,
            currentMonth,
            edit,
            countries,
            programs,
            obrasType,
            jefeDeEquipos,
            currency,
            estadoDeEjecucion,
            notificacion as NotificationAlert
        );
    };

    function rowKeyGetter(row: ObraAppTemporal) {
        return row.oid as number;
    }

    const rowClassName = (data: ObraAppTemporal) => {
        if (data.rowClass) {
            return data.rowClass as string;
        } else return 'global-custom-row';
    };

    const approveNotification = async () => {
        if (notificacion) {
            notificacion.statusId = 1;

            notificacion.modifiedBy = user?.username;
            await notificationsService.updateNotification(notificacion);

            await obrasService
                .saveObrasApp(
                    obras.map((obraUni: ObraAppTemporal) => {
                        const obra: ObraApp = {
                            oid: obraUni.oidObra,
                            actaSuspencionFirmada: obraUni.actaSuspencionFirmada,
                            cantidadManoObra: obraUni.cantidadManoObra,
                            cantidadObreroCesados: obraUni.cantidadObreroCesados,
                            estadoEjecucion: obraUni.estadoEjecucion,
                            estadoEjecucionItem: obraUni.estadoEjecucionItem,
                            fecha: obraUni.fecha,
                            fechaActualizacion: new Date(),
                            actaSuspencionMesFirma: obraUni.actaSuspencionMesFirma,
                            fechaFinalizacionEstimada: obraUni.fechaFinalizacionEstimada,
                            fechaFinalizacionVigente: obraUni.fechaFinalizacionVigente,
                            fechaInicio: obraUni.fechaInicio,
                            flexibilizacionClausulasContractuales:
                                obraUni.flexibilizacionClausulasContractuales,
                            jefeEquipo: obraUni.jefeEquipo,
                            jefeEquipoItem: obraUni.jefeEquipoItem,
                            latitud: obraUni.latitud,
                            gcrecord: obraUni.gcrecord,
                            limitacionActividadesAdministrativas:
                                obraUni.limitacionActividadesAdministrativas,
                            index: obraUni.index,
                            locked: obraUni.locked,
                            longitud: obraUni.longitud,
                            longitudKm: obraUni.longitudKm,
                            mesUltPagoContratista: obraUni.mesUltPagoContratista,
                            moneda: obraUni.moneda,
                            monedaItem: obraUni.monedaItem,
                            montoInicial: obraUni.montoInicial,
                            montoVigente: obraUni.montoVigente,
                            nombre: obraUni.nombre,
                            nota: obraUni.nota,
                            nuevoCronograma: obraUni.nuevoCronograma as string,
                            optimisticLockField: obraUni.optimisticLockField,
                            orden: obraUni.orden,
                            pagado: obraUni.pagado,
                            pagoStockMateriales: obraUni.pagoStockMateriales,
                            pais: obraUni.pais,
                            paisItem: obraUni.paisItem,
                            pendientePorVerificar: obraUni.pendientePorVerificar,
                            plazoInicialMeses: obraUni.plazoInicialMeses,
                            porcentajeBid: obraUni.porcentajeBid,
                            porcentajeContrapartida: obraUni.porcentajeContrapartida,
                            problemaCadenaSuministros: obraUni.problemaCadenaSuministros,
                            programItem: obraUni.programItem,
                            programa: obraUni.programa,
                            provincia: obraUni.provincia,
                            sobreCostoEstimado: obraUni.sobreCostoEstimado,
                            sobreCostoEstimadoNoMaterializado:
                                obraUni.sobreCostoEstimadoNoMaterializado,
                            seSuscribioAdenda: obraUni.seSuscribioAdenda,
                            tipoCambio: obraUni.tipoCambio,
                            tipoObra: obraUni.tipoObra,
                            tipoObraItem: obraUni.tipoObraItem,
                            tramo: obraUni.tramo,
                            rowClass: obraUni.rowClass,
                            anoFinalizaciónContrato: obraUni.anoFinalizaciónContrato,
                            apareceEnBaseDeDatos: obraUni.apareceEnBaseDeDatos,
                            avanceDePlazoPlazoIntermedio: obraUni.avanceDePlazoPlazoIntermedio,
                            clasificacionDeSobrecostos: obraUni.clasificacionDeSobrecostos,
                            clasificacionPorKm: obraUni.clasificacionPorKm,
                            clasificacionPorMontos: obraUni.clasificacionPorMontos,
                            clasificacionPorPlazo: obraUni.clasificacionPorPlazo,
                            clasificacionPorSobreplazo: obraUni.clasificacionPorSobreplazo,
                            contratista1: obraUni.contratista1,
                            contratista2: obraUni.contratista2,
                            contratistaConsorciosObra: obraUni.contratistaConsorciosObra,
                            desapareceDeBaseDeDatos: obraUni.desapareceDeBaseDeDatos,
                            empresaSupervisora: obraUni.empresaSupervisora,
                            estadoDeAvanceGeneral: obraUni.estadoDeAvanceGeneral,
                            externalIdCaptudata1: obraUni.externalIdCaptudata1,
                            externalIdcaptudata: obraUni.externalIdcaptudata,
                            f103: obraUni.f103,
                            fechaDeOrdenDeInicioEnMesAño: obraUni.fechaDeOrdenDeInicioEnMesAño,
                            fechaRecibioInformación: obraUni.fechaRecibioInformación,
                            ficConTazasCambioDiferenciadas: obraUni.ficConTazasCambioDiferenciadas,
                            ficmetodologicoContratosActivos:
                                obraUni.ficmetodologicoContratosActivos,
                            ficmetodologicoContratosActivosSinCeros:
                                obraUni.ficmetodologicoContratosActivosSinCeros,
                            fpcmetodologicoContratosActivos:
                                obraUni.fpcmetodologicoContratosActivos,
                            fpcmetodologicoContratosActivosSinCeros:
                                obraUni.fpcmetodologicoContratosActivosSinCeros,
                            localizacion: obraUni.localizacion,
                            manoObraPorMontoDeInversionMillones:
                                obraUni.manoObraPorMontoDeInversionMillones,
                            mesDelÚltimoPagoAlContratistaEnMesAño:
                                obraUni.mesDelÚltimoPagoAlContratistaEnMesAño,
                            montoContractualDolares: obraUni.montoContractualDolares,
                            montoContractualDolaresEnMillones:
                                obraUni.montoContractualDolaresEnMillones,
                            montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                                obraUni.montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                            montoContractualVigenteModificadoDolares:
                                obraUni.montoContractualVigenteModificadoDolares,
                            montoContractualVigenteModificadoDolaresEnMillones:
                                obraUni.montoContractualVigenteModificadoDolaresEnMillones,
                            montoContractualVigenteModificadoDólaresConTasaDeCam:
                                obraUni.montoContractualVigenteModificadoDólaresConTasaDeCam,
                            muestraDeChequeo: obraUni.muestraDeChequeo,
                            nacionalidadContratista: obraUni.nacionalidadContratista,
                            nacionalidadEmpresaSupervisora: obraUni.nacionalidadEmpresaSupervisora,
                            notaFinalEstadoGeneral: obraUni.notaFinalEstadoGeneral,
                            notaFinalSobrecostos: obraUni.notaFinalSobrecostos,
                            notaFinalSobreplazo: obraUni.notaFinalSobreplazo,
                            plazoContractualVigente: obraUni.plazoContractualVigente,
                            plazoContractualVigentePasoIntermedio:
                                obraUni.plazoContractualVigentePasoIntermedio,
                            plazoInicialPorKm: obraUni.plazoInicialPorKm,
                            plazoVigentePorKm: obraUni.plazoVigentePorKm,
                            ponderadorFicMca: obraUni.ponderadorFicMca,
                            ponderadorFicMcasinCeros: obraUni.ponderadorFicMcasinCeros,
                            ponderadorPfc: obraUni.ponderadorPfc,
                            ponderadorPfcMcasinCeros: obraUni.ponderadorPfcMcasinCeros,
                            porcentajeAvanceAcumulado: obraUni.porcentajeAvanceAcumulado,
                            porcentajeAvanceDePlazo: obraUni.porcentajeAvanceDePlazo,
                            precioInicialPorKmMillones: obraUni.precioInicialPorKmMillones,
                            precioVigentePorKmMillones: obraUni.precioVigentePorKmMillones,
                            sobrecostosMaterializados: obraUni.sobrecostosMaterializados,
                            sobrecostosUsd: obraUni.sobrecostosUsd,
                            sobrecostosUsdenMillones: obraUni.sobrecostosUsdenMillones,
                            sobreplazoMesesCalculado: obraUni.sobreplazoMesesCalculado,
                            subRegion: obraUni.subRegion,
                            supervisora1: obraUni.supervisora1,
                            tipoCambioPorMesYmoneda: obraUni.tipoCambioPorMesYmoneda,
                            tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                                obraUni.tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                            tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                                obraUni.tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                            totalPagoHastaLaFechaDolares: obraUni.totalPagoHastaLaFechaDolares,
                            _: obraUni._,
                            _2020: obraUni._2020,
                            _2021: obraUni._2021,
                            _2022: obraUni._2022,
                            _2023: obraUni._2023,
                            _2024: obraUni._2024,
                            _2025: obraUni._2025,
                        };
                        return obra;
                    })
                )
                .then((resp) => {});
        }

        props.changeNotifications();
        navigate('/notifications');
    };

    const rejectNotification = async () => {
        if (notificacion) {
            notificacion.statusId = 2;
            notificacion.modifiedBy = user?.username;
            await notificationsService.updateNotification(notificacion);
            props.changeNotifications();
            navigate('/notifications');
        }
    };

    const getStatusString = () => {
        let statusName: string = '';
        if (notificacion) {
            const statusFilter = General.NotificationStatus.filter(
                (s) => s.Id === notificacion.statusId
            );
            if (statusFilter.length > 0) {
                statusName = statusFilter[0].Name;
            }
        }
        return statusName;
    };

    return (
        <section id='create' className='bg-gray'>
            <div className='container cont-in'>
                <div className='row justify-content-between'>
                    <div className='col-12 col-md-7'>
                        <h3>Detalle - Actualización Avance de Proyectos</h3>
                    </div>
                    <div className='col-12 col-md-5'>
                        {notificacion && notificacion.statusId === 0 && (
                            <div className='row justify-content-end'>
                                <div className='col-12 col-md-6'>
                                    <button
                                        className='approved btn'
                                        onClick={() => {
                                            approveNotification();
                                        }}>
                                        Aprobar
                                    </button>
                                    <button
                                        className='cancel btn'
                                        onClick={() => {
                                            rejectNotification();
                                        }}>
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <span>
                    <b>Estado:</b> {getStatusString()}
                </span>
                <br />
                <div className='row'>
                    <div className='col-12 col-md-4'>
                        <p>
                            <b>Programa:</b>{' '}
                        </p>
                        <DropDownList
                            data={programs || []}
                            disabled={true}
                            textField='descripcion'
                            dataItemKey='oid'
                            onChange={handleChangeProgram}
                            defaultValue={programSelected.value}></DropDownList>
                    </div>
                    <div className='col-12 col-md-8'>
                        {/* <p className="text-center">Periodo: </p> */}
                        <div className='d-flex'>
                            <div className='col-12 col-md-6'>
                                <p>
                                    <b> Año:</b>{' '}
                                </p>
                                <DropDownList
                                    disabled={true}
                                    data={years()}
                                    onChange={handleChangeYear}
                                    defaultValue={currentYear}></DropDownList>
                            </div>
                            <div className='col-12 col-md-6'>
                                <p>
                                    <b> Mes:</b>{' '}
                                </p>
                                <DropDownList
                                    disabled={true}
                                    data={months()}
                                    onChange={handleChangeMonth}
                                    defaultValue={currentMonth}></DropDownList>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        {columnasGrid && obras && (
                            <ReactDataGrid
                                columns={columnasGrid}
                                rows={obras}
                                onRowsChange={setObras}
                                headerRowHeight={100}
                                rowKeyGetter={rowKeyGetter}
                                rowClass={rowClassName}
                                className='dataGridContainer'
                            />
                        )}
                    </div>
                </div>
                {loading && (
                    <div className='loading'>
                        <Loading />
                    </div>
                )}
            </div>
        </section>
    );
}
